import create from "zustand";

const initialSettings = {
  quotation_id: null,
  draftQuotationId: null,
  rows: null, // 15,
  columns: null, // 15,
  numRows: null, // 60,
  numCols: null, // 60,
  line: null, // 1,  // NOTE: It's actually the numeric material ID!
  oldLine: null, // Use for detect and upgrade or downgrade of line
  visibleFacesVariation: 0,
  hiddenFacesVariation: 0,
  nonVisibleFacesAvailable: false,
  height: null, // 1,
  clientData: {
    offerNumber: null, // '',
    date: null, // new Date(),
    infos: null, // '',
    notes: null, // ''
    references: null, // ''
  },
  plan: [],
  canvas3DScreenshot: 0,
  complementiAttivi: false,
};

const usePlannerSettings = create((set) => ({
  ...initialSettings,
  setQuotationId: (quotation_id) => {
    set({ quotation_id: quotation_id });
  },
  setDraftQuotationId: (draftQuotationId) => {
    set({ draftQuotationId: draftQuotationId });
  },
  setPlanSize: (x, y) => {
    set({ numCols: x, numRows: y });
  },
  setLine: (line) => {
    set({ line: line });
  },
  setPlanOldLine: (line) => {
    set({ oldLine: line });
  },
  setVisibleFacesVariation: (variation) => {
    set({ visibleFacesVariation: variation });
  },
  setHiddenFacesVariation: (variation) => {
    set({ hiddenFacesVariation: variation });
  },
  setNonVisibleFacesAvailable: (availability) => {
    set({ nonVisibleFacesAvailable: availability });
  },
  setHeight: (height) => {
    set({ height: height });
  },
  setClientData: (clientData) => {
    set({ clientData: clientData });
  },
  setPlan: (plan) => {
    set({ plan: plan });
  },
  setPlannerSettings: (settings) => {
    set(settings);
  },
  resetPlannerSettings: () => {
    set(initialSettings);
  },
  takeCanvas3DScreenshot: () => {
    set((state) => ({ canvas3DScreenshot: state.canvas3DScreenshot + 1 }));
  },
  setComplementiAttivi: (value) => set({ complementiAttivi: value }),
}));

export default usePlannerSettings;
